import * as React from "react";
import * as SwitchPrimitives from "@radix-ui/react-switch";

import { cn } from "../../utils/classes";
import styles from "./switch.module.css";

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root> & {
    appearance?: "legacy" | "system";
  }
>(({ className, appearance = "legacy", ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(styles.root, className)}
    data-appearance={appearance}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb className={styles.thumb} />
  </SwitchPrimitives.Root>
));
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
